import * as fs from "fs";
import * as path from "path";
export function createFile(filename, data) {
    return new Promise((resolve, reject) => {
        const fullpath = path.resolve(filename);
        if (fs.existsSync(fullpath)) {
            return reject(`File ${filename} already exists.`);
        }
        fs.writeFile(fullpath, data, err => {
            if (err) {
                reject(err);
            }
            resolve();
        });
    });
}
